export function setGeneralInfo(state, data) {
  state.promos_count = data.cantidad_promociones
  state.advertisements_count = data.cantidad_anuncios
  state.discount_beer = data.descuento_cerveza
  state.discounts_x_amount = data.descuentos_monto
  state.special_price_products = data.productos_precios_especiales
}
